module.exports = __webpack_public_path__ + "static/media/time-stamp.92c4ef48.png";